export let refTimeout;

export const refreshCart = (callback) => {
    clearTimeout(refTimeout);
    
    refTimeout = setTimeout(function () {
        callback()
    }, 2000);
};

export const reloadCart = () => {
    console.log('refreshed');
};

export const removeProduct = (callback) => {
  callback();
};


// WEBPACK FOOTER //
// ./components/Cart/cartActions/cartActions.js